import { render, staticRenderFns } from "./LifecycleHooks.vue?vue&type=template&id=02b33d16&"
import script from "./LifecycleHooks.vue?vue&type=script&lang=js&"
export * from "./LifecycleHooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports